import { defineComponent as _defineComponent } from 'vue';
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "formInputUI" };
const _hoisted_2 = ["type", "value"];
import { computed, ref } from 'vue';
import ThemeIcon from '../../shared/Icon/Icon.vue';
const __default__ = {
    inheritAttrs: false,
};
export default /*@__PURE__*/ _defineComponent(Object.assign(Object.assign({}, __default__), { __name: 'InputPassword', props: {
        type: {},
        modelValue: {}
    }, setup(__props, { expose: __expose }) {
        const props = __props;
        const showPassword = ref(false);
        const iconName = computed(() => {
            return showPassword.value ? 'eye-off-outline' : 'eye-outline';
        });
        const inputEl = ref();
        __expose({
            focus: () => {
                var _a;
                (_a = inputEl.value) === null || _a === void 0 ? void 0 : _a.focus();
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("input", _mergeProps({
                    ref_key: "inputEl",
                    ref: inputEl,
                    type: showPassword.value ? 'text' : 'password',
                    value: _ctx.modelValue,
                    class: "formInput"
                }, _ctx.$attrs, {
                    onInput: _cache[0] || (_cache[0] = ($event) => { var _a; return (_ctx.$emit('update:modelValue', (_a = inputEl.value) === null || _a === void 0 ? void 0 : _a.value)); })
                }), null, 16, _hoisted_2),
                _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = ($event) => (showPassword.value = !showPassword.value))
                }, [
                    _createVNode(ThemeIcon, { name: iconName.value }, null, 8, ["name"])
                ])
            ]));
        };
    } }));
